import React from "react";

const BusinessVerified = () => {
  const videoID = "bSj2-_fqc5U"; // YouTube video ID

  return (
    <div className="max-w-[1200px] mx-auto m-0 relative isolate mt-10 sm:mt-16 md:mt-24 lg:mt-[50px] py-5 sm:py-16 md:py-20 lg:py-30">
      <h1 className="max-w-[1200px] mx-auto px-2 uppercase sm:normal-case sm:px-8 md:px-2 lg:px-2 text-f24 sm:text-f32 md:text-f40 font-bold text-[#012234] sm:mb-2">
      Become a Verified Business on TREVEX
      </h1>
      <h6 className="sm:max-w-[1200px] md:max-w-[1200px] mx-auto px-2 text-f14 sm:text-f16 md:text-f18 text-[#3C4848] mb-8 sm:mb-12 lg:mb-8">
      Choose to get verified and stand out as a credible business among your peers
      </h6>
      <div className="flex justify-center mt-[32px] sm:mt-[-20px]">
        <iframe
          className="md:w-[100%] md:h-[560px] sm:w-[90%] w-full px-4 sm:h-[300px] md:px-4 md:rounded-[0.5rem] mx-auto sm:mt-10 rounded-lg sm:rounded-[0.5rem]"
          src={`https://www.youtube.com/embed/${videoID}`}
          title="Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default BusinessVerified;
